import { createUserMessage } from '@/ai/utils/promptUtils'

export const chatLogType = {
  USER_PROMPT: 'user-prompt',
  AI_TEXT_RESPONSE: 'ai-text-response',
  AI_FUNCTION_CALL: 'ai-function-call'
}

export const constructMessagesHistory = (messages) => {
  const outputs = []

  for (const message of messages) {
    switch (message.type) {
      case chatLogType.USER_PROMPT:
        outputs.push(createUserMessage(message.content))
        break
      case chatLogType.AI_TEXT_RESPONSE:
        if (!message.aiOutput) {
          if (message.content) {
            outputs.push({
              type: 'message',
              role: 'assistant',
              content: [{ type: 'output_text', text: message.content }]
            })
          }
          continue
        }

        const output = JSON.parse(message.aiOutput).find((item) => item.type === 'message')
        outputs.push(output)
        break
      case chatLogType.AI_FUNCTION_CALL:
        if (!message.aiOutput) {
          continue
        }

        const parsedOutput = JSON.parse(message.aiOutput)

        const functionCallOutput = Array.isArray(parsedOutput) ? parsedOutput : parsedOutput.output
        const functionResults = Array.isArray(parsedOutput) ? [] : (parsedOutput.functionResults || [])

        for (const item of functionCallOutput) {
          if (item.type === 'function_call') {
            outputs.push(item)

            const storedResult = functionResults.find((r) => r.callId === item.call_id)
            outputs.push({
              type: 'function_call_output',
              call_id: item.call_id,
              output: JSON.stringify(storedResult?.result ?? { success: true })
            })
          }
        }

        if (message.content) {
          outputs.push({
            type: 'message',
            role: 'assistant',
            content: [{ type: 'output_text', text: message.content }]
          })
        }
        break
    }
  }

  return outputs
}
